import React from 'react';
import PropTypes from 'prop-types';

import TextInputField from './TextInputField';

import { translate } from 'translations/i18n';

const Password = ({ 'aria-describedby': ariaDescribedBy }) => {
  return (
    <TextInputField
      type="password"
      name="password"
      placeholder={translate('common.password')}
      addEyeIcon
      aria-describedby={ariaDescribedBy}
    />
  );
};

Password.propTypes = { 'aria-describedby': PropTypes.string };

export default Password;
